import { render } from "./VesselProtocolPrevisionalCommercialInfo.vue?vue&type=template&id=712412cb&scoped=true"
import script from "./VesselProtocolPrevisionalCommercialInfo.vue?vue&type=script&lang=js"
export * from "./VesselProtocolPrevisionalCommercialInfo.vue?vue&type=script&lang=js"

import "./VesselProtocolPrevisionalCommercialInfo.vue?vue&type=style&index=0&id=712412cb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712412cb"]])

export default __exports__